Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headingResets = exports.heading6Reset = exports.heading5Reset = exports.heading4Reset = exports.heading3Reset = exports.heading2Reset = exports.heading1Reset = exports.headingReset = void 0;
exports.headingReset = {
  ncss: {
    boxSizing: 'border-box',
    fontFamily: 'text'
  }
};
exports.heading1Reset = {
  ncss: Object.assign({
    fontSize: '2em',
    my: '0.67em',
    mx: '0'
  }, exports.headingReset.ncss)
};
exports.heading2Reset = {
  ncss: Object.assign({}, exports.headingReset.ncss)
};
exports.heading3Reset = {
  ncss: Object.assign({}, exports.headingReset.ncss)
};
exports.heading4Reset = {
  ncss: Object.assign({}, exports.headingReset.ncss)
};
exports.heading5Reset = {
  ncss: Object.assign({}, exports.headingReset.ncss)
};
exports.heading6Reset = Object.assign({}, exports.headingReset.ncss);
exports.headingResets = {
  h1: exports.heading1Reset,
  h2: exports.heading2Reset,
  h3: exports.heading3Reset,
  h4: exports.heading4Reset,
  h5: exports.heading5Reset,
  h6: exports.heading6Reset
};